import * as Yup from 'yup';

// Should be https and do not contain any parameter
// @ts-expect-error TS7006 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
const exchangeTokenSchema = (t) => ({
  redirectUri: Yup.string()
    .url()
    .required()
    .matches(/^https:\/\/[^?]+\/*$/, t('pageExchangeToken.invalidURI')),
});

export default exchangeTokenSchema;
